import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── QR codes (§7) ─────────────────────────────────────────────────────

export type CampaignQrData = {
  campaign_id: string;
  landing_url: string;
  qr_url: string;
  qr_code_data: string;
};

/** Fetch JSON QR data from `GET /api/qr/{campaign_id}`. Renders `<img src={qr_url} />`. */
export async function fetchCampaignQr(campaignId: string, axiosInstance?: AxiosInstance): Promise<CampaignQrData | null> {
  const client = axiosInstance || getVoiceFallbackClient();
  const url = `${apiConfig.voiceEndpoints.qr}/${campaignId}`;
  const response = await client.get<CampaignQrData>(url);
  return response.data ?? null;
}
